import React from 'react';
import '../dialpad/style.css';

const DialpadKeypad = ({ value, onChange, onEnter }) => {
  const handleBtnClick = (digit) => {
    const newValue = value + digit;
    onChange(newValue);
  };

  const handleChange = (e) => {
    const val = e.target.value.replace(/[^0-9*#]/g, '');
    onChange(val);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter();
    }
  };

  return (
    <div className="numPan" style={{ padding: '0', boxShadow: 'none' }}>
      <div className="disp">
        <input
          type="text"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="Digite o número..."
          autoFocus
        />
      </div>
      <div className="nums">
        <div className="r r1">
          {['1', '2', '3'].map((n) => (
            <div key={n} onClick={() => handleBtnClick(n)}>
              <span>{n}</span>
            </div>
          ))}
        </div>
        <div className="r r2">
          {['4', '5', '6'].map((n) => (
            <div key={n} onClick={() => handleBtnClick(n)}>
              <span>{n}</span>
            </div>
          ))}
        </div>
        <div className="r r3">
          {['7', '8', '9'].map((n) => (
            <div key={n} onClick={() => handleBtnClick(n)}>
              <span>{n}</span>
            </div>
          ))}
        </div>
        <div className="r r4">
          <div onClick={() => handleBtnClick('*')}>
            <span>*</span>
          </div>
          <div onClick={() => handleBtnClick('0')}>
            <span>0</span>
          </div>
          <div onClick={() => handleBtnClick('#')}>
            <span>#</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialpadKeypad;
